import { padLeft } from './padLeft';

export const formatDateString = (value: string) : string => {
  if (value === null) {
    return '-';
  }

  const date = new Date(value);

  const day = padLeft(date.getDate());
  const month = padLeft(date.getMonth() + 1);
  const year = date.getFullYear();
  const minute = padLeft(date.getMinutes());

  let hour = date.getHours();
  let suffix = 'am';

  if (hour >= 12) {
    suffix = 'pm';

    if (hour > 12) {
      hour -= 12;
    }
  }

  return `${day}/${month}/${year} ${padLeft(hour)}:${minute}${suffix}`;
};
